/**
 * ButtonGroup
 * This is a wrapper for the ToggleButtonGroup mUI component
 */
import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '../..';
const useStyles = makeStyles(({ palette, spacing }) => createStyles({
    defaultButton: {
        height: spacing(4),
        color: palette.text.primary,
        backgroundColor: palette.background.default,
        borderColor: palette.divider,
        borderLeftColor: `${palette.divider} !important`,
    },
    selectedButton: {
        backgroundColor: `${palette.common.white} !important`,
        color: `${palette.secondary.main} !important`,
        borderColor: palette.divider,
    },
}));
export const ButtonGroup = ({ options, ...rest }) => {
    const classes = useStyles();
    const buttonClasses = { root: classes.defaultButton, selected: classes.selectedButton };
    return (React.createElement(ToggleButtonGroup, Object.assign({}, rest), options.map(option => {
        return (React.createElement(ToggleButton, { key: JSON.stringify(option), value: option.value, classes: buttonClasses }, option.label));
    })));
};
//# sourceMappingURL=ButtonGroup.js.map